export const faqItems = [
  {
    question: '鲍鱼视频平台的内容是否免费观看？',
    answer: '是的，鲍鱼视频平台上的所有视频内容均免费观看。我们致力于为海鲜爱好者和水产从业者提供高质量的鲍鱼知识科普内容，无需任何付费即可畅享全部视频资源。部分高清教程视频支持离线缓存功能。',
  },
  {
    question: '鲍鱼养殖需要什么样的水质条件？',
    answer: '鲍鱼养殖对水质要求较高，主要指标包括：水温15-22℃为最适范围，溶解氧需≥5mg/L，盐度保持在28-35‰，pH值在7.8-8.2之间，氨氮含量需低于0.2mg/L。良好的水质管理是鲍鱼养殖成功的关键，建议每日监测各项水质指标并做好记录。',
  },
  {
    question: '如何辨别野生鲍鱼和养殖鲍鱼？',
    answer: '野生鲍鱼和养殖鲍鱼的主要区别在于：①外壳颜色：野生鲍鱼壳色更深沉，养殖鲍鱼壳色相对均匀；②壳表纹理：野生鲍鱼生长纹更密集不规则，养殖鲍鱼纹理较为规整；③肉质口感：野生鲍鱼肉质更紧实弹牙，鲜味更浓郁；④价格差异：同规格下野生鲍鱼价格通常是养殖鲍鱼的2-4倍。我们在品种鉴别栏目中有专门的对比视频，欢迎观看。',
  },
  {
    question: '干鲍鱼如何正确泡发？',
    answer: '干鲍鱼泡发需要耐心，一般流程为：①清水浸泡24-48小时，期间每6-8小时换水一次；②待鲍鱼变软后，用刷子刷洗干净；③放入锅中加清水和姜片，小火慢煮2-4小时；④煮至可以用筷子轻松插入即可。整个泡发过程约需48-72小时。泡发好的鲍鱼应立即烹饪食用，不宜长时间存放。',
  },
  {
    question: '鲍鱼视频平台多久更新一次内容？',
    answer: '我们保持每周更新3-5个新视频的节奏，内容涵盖养殖新技术、名厨烹饪教学、鲍鱼知识科普等各个栏目。遇到鲍鱼捕捞季节或行业重要活动时，还会增加特别专题内容。建议关注我们的平台并开启通知，第一时间获取最新视频更新信息。',
  },
  {
    question: '鲍鱼哪些部位可以吃，哪些不能吃？',
    answer: '鲍鱼的可食用部分主要是腹足肌肉（即鲍鱼肉），这是最精华的部分。需要去除的部位包括：①内脏团：位于鲍鱼肉下方，颜色较深；②嘴巴：位于鲍鱼头部，质地坚硬；③裙边上的黏液：需用盐水搓洗干净。去除这些不可食用部分后，剩下的鲍鱼肉质洁白，即可进行烹饪。',
  },
  {
    question: '如何联系鲍鱼视频平台进行商务合作？',
    answer: '我们欢迎各类商务合作，包括视频内容授权、广告投放、品牌联名等。您可以通过关于我们页面上的联系方式与我们取得联系，发送邮件至合作邮箱，或在工作时间拨打商务合作热线。我们的商务团队会在1-2个工作日内回复您的咨询。',
  },
  {
    question: '鲍鱼的最佳食用季节是什么时候？',
    answer: '鲍鱼的最佳食用季节是秋冬季（10月至次年2月）。这个时期的鲍鱼经过夏秋两季的摄食生长，肉质最为肥厚鲜美。干鲍鱼则全年均可食用，品质稳定。鲜鲍鱼购买时建议选择秋冬季节，此时市场供应充足，价格也相对合理。春夏季虽然也有鲍鱼供应，但肉质和风味略逊于秋冬。',
  },
];